/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import * as S from './Table.styles';

import { Trans } from 'react-i18next';
import { Toggle } from '@social-solutions/component-library';

const ToggleCell = ({
    row: { original },
    column: { id },
    updateToggleData,
}: {
    row: any,
    column: any,
    updateToggleData: (data: any, rowKey: string, value: any) => void
  }) => {
    const [value, setValue] = React.useState(original.Status);
    const onChange: React.ChangeEventHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.checked);
        updateToggleData(original, id, e.target.checked);
    };
  
    React.useEffect(() => {
        setValue(original.Status);
    }, [original]);
  
    return (
        <S.ToggleContainer>
            <span>{value ? <Trans>CONFIGURATION.TOGGLE_ENABLED_LABEL</Trans> : <Trans>CONFIGURATION.TOGGLE_DISABLED_LABEL</Trans>}</span>
            <Toggle
                initialState={value}
                onChange={onChange}
            />
        </S.ToggleContainer>
    );
};

export default ToggleCell;